import { render, staticRenderFns } from "./homeParts.vue?vue&type=template&id=2ece5632&scoped=true&"
import script from "./homeParts.vue?vue&type=script&lang=js&"
export * from "./homeParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece5632",
  null
  
)

export default component.exports